import { createFileRoute, Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/calendar")({
	component: Calendar,
});

function Calendar() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">
					Using the calendar
				</h1>
				<p className="text-sm text-muted-foreground">
					A visual overview of your content schedule.
				</p>
			</div>
			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>
					The Calendar gives you a visual overview of all scheduled and
					published posts. You can switch between week and month views.
				</p>
				<ul className="list-disc pl-5 space-y-1">
					<li>Click a day to see all posts for that date.</li>
					<li>Click a post chip to open and edit it.</li>
					<li>
						Posts are color-coded by status: scheduled, published, or failed.
					</li>
				</ul>
				<p>
					The calendar shows posts across all connected channels in one place,
					so you can spot gaps or overlaps in your publishing schedule.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Checking your schedule via MCP
				</h2>
				<p>You can ask your AI assistant to show you what is coming up:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="What do I have scheduled this week?"
						multiline
					/>
					<SetupCopyBlock
						text="Show me all upcoming posts by target."
						multiline
					/>
					<SetupCopyBlock text="List my recent posts." multiline />
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postPlan
					</code>{" "}
					to pull your schedule and present it in a readable format.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/scheduling-posts"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Scheduling posts
				</Link>
				<Link
					to="/docs/inviting-members"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Inviting members &rarr;
				</Link>
			</div>
		</article>
	);
}
